import { ReactNode } from "react"
import styled from "styled-components"

import { breakpoint, colors, spacing, Text } from "@minuthq/meatball-ui-react"
import { SessionSelectDropdown } from "src/domains/session/session-select-dropdown"
import { Card } from "src/ui/card/card"
import { Divider } from "src/ui/divider/divider"
import { ImageBackdrop } from "src/ui/image-backdrop/image-backdrop"

export function PageLayout({
  title,
  description,
  footer,
  landscapeImageUrl,
  portraitImageUrl,
  children,
  showDivider = true,
}: {
  title?: ReactNode
  description?: string
  landscapeImageUrl: string
  portraitImageUrl: string
  children?: ReactNode
  footer?: ReactNode
  showDivider?: boolean
}) {
  return (
    <ImageBackdrop
      landscapeImageUrl={landscapeImageUrl}
      portraitImageUrl={portraitImageUrl}
      backgroundColor={colors.neutral}
    >
      <SessionSelectDropdown />

      <StyledCard>
        <Grid>
          <div>
            {title && (
              <Text variant="heading1" marginBottom={spacing.XS}>
                {title}
              </Text>
            )}
            {description && <Text variant="body">{description}</Text>}
          </div>

          {children}

          {footer && (
            <>
              {showDivider && <Divider />}
              <div>{footer}</div>
            </>
          )}
        </Grid>
      </StyledCard>
    </ImageBackdrop>
  )
}

const StyledCard = styled(Card)`
  position: relative;
  padding: ${spacing.L};
  overflow: visible;

  @media (${breakpoint.mediumUp}) {
    max-width: 55ch;
    padding: ${spacing.XL2};
  }
`

const Grid = styled.div`
  display: grid;
  gap: ${spacing.L};
`
